module.exports = __webpack_public_path__ + "static/media/maci_header_mobile.91a4a351.png";